import React from "react";
import { Scale, HandHeart, Sparkles, Flower2, Landmark } from "lucide-react";

const VALUES = [
    {
        title: "Discipline",
        body: "Developing dedication and consistency through regular practice.",
        Icon: Scale,
    },
    {
        title: "Respect",
        body: "Honouring teachers, traditions, and fellow learners.",
        Icon: HandHeart,
    },
    {
        title: "Excellence",
        body: "Encouraging students to achieve their highest potential.",
        Icon: Sparkles,
    },
    {
        title: "Compassion",
        body: "Fostering kindness, empathy, and universal brotherhood.",
        Icon: Flower2,
    },
    {
        title: "Cultural Heritage",
        body: "Preserving and celebrating the rich traditions of Indian music.",
        Icon: Landmark,
    },
];

const WHY = [
    "Hindustani Classical Vocal Training",
    "Bhajans & Devotional Music",
    "Value-Based Education & Cultural Awareness",
    "Traditional Guru-Shishya Methodology",
    "Online & Offline Classes",
    "Performance & Stage Exposure",
    "Examination & Competition Preparation",
    "Programs for Children, Youth & Adults",
    "Personalised Attention & Mentorship",
];

export default function WhyChooseValues() {
    return (
        <section
            id="why"
            data-testid="why-section"
            className="section-pad bg-ivory"
        >
            <div className="max-w-7xl mx-auto px-6 lg:px-10 grid grid-cols-1 lg:grid-cols-12 gap-14">
                <div className="lg:col-span-5">
                    <div className="eyebrow">· Why Choose Us ·</div>
                    <h2 className="font-display text-4xl sm:text-5xl text-maroon mt-4 leading-tight">
                        Music refines the mind.
                        <span className="block italic text-gold">Values refine life.</span>
                    </h2>
                    <p className="mt-6 font-serif text-lg text-ink/80 leading-relaxed">
                        Our approach combines rigorous musical training with
                        character-building principles, helping students grow
                        intellectually, emotionally, culturally and spiritually.
                    </p>

                    <ul className="mt-10 grid grid-cols-1 gap-3 text-lg" data-testid="why-list">
                        {WHY.map((w) => (
                            <li
                                key={w}
                                className="flex items-start gap-3 font-serif text-ink/85"
                            >
                                <span className="mt-2 inline-block h-[7px] w-[7px] rotate-45 bg-gold" />
                                {w}
                            </li>
                        ))}
                    </ul>
                </div>

                <div className="lg:col-span-7">
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
                        {VALUES.map(({ title, body, Icon }, i) => (
                            <div
                                key={title}
                                data-testid={`value-card-${title.toLowerCase().replace(/\s+/g, "-")}`}
                                className={`card-cream p-7 ${i === 4 ? "sm:col-span-2" : ""}`}
                            >
                                <div className="flex items-center justify-between">
                                    <div className="w-11 h-11 flex items-center justify-center border border-gold/40 text-maroon">
                                        <Icon size={18} />
                                    </div>
                                    <span className="font-display italic text-gold text-3xl">
                                        {String(i + 1).padStart(2, "0")}
                                    </span>
                                </div>
                                <h3 className="font-display text-2xl text-maroon mt-5">
                                    {title}
                                </h3>
                                <p className="font-serif text-base lg:text-[17px] text-ink/80 mt-3 leading-relaxed">
                                    {body}
                                </p>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
}
